<div class="icon-nav">
  <ul>
    <li class="onhover-div mobile-cart">
      <div>
        <a [routerLink]="['/shop/cart']">
          <img src="web/assets/images/icon/cart.png" class="img-fluid" alt="">
          <i class="ti-shopping-cart"></i>
        </a>
      </div>
      <span class="cart_qty_cls">{{ products.length }}</span>
      <ng-container *ngIf="innerWidth > 450">
        <ul class="show-div shopping-cart" *ngIf='!products.length'>
          <h5>Il tuo carrello e' vuoto</h5>
        </ul>
        <ul class="show-div shopping-cart" *ngIf='products.length'>
          <li *ngFor="let product of products">
            <div class="media">
              <a [routerLink]="['/shop/product/', product?.product.id]">
                <img class="me-3" [src]="product?.product.thumbnail.imageUrl" [alt]="'ciao'">
              </a>
              <div class="media-body">
                <a [routerLink]="['/shop/product/', product?.product.id]">
                  <h4>{{ product?.product.title }}</h4>
                </a>
                <h4>
                  <span>
                    {{ product?.quantity }} x {{ product?.product.price }}
                  </span><br/>
                  <span *ngIf="product?.size !== 'single'">Taglia: {{ product?.size.toUpperCase() }}</span>
                  <span *ngIf="product?.size === 'single'">Taglia: UNICA</span>
                </h4>
              </div>
            </div>
            <div class="close-circle" (click)="removeItem(product)">
              <a href="javascript:void(0)">
                <fa-icon [icon]="faTrash"></fa-icon>
              </a>
            </div>
          </li>
          <li>
            <div class="total">
              <h5>Sub totale : <span>€ {{ getSubTotal() }}</span></h5>
            </div>
          </li>
          <li>
            <div class="buttons">
              <a [routerLink]="['/shop/cart']" class="view-cart">Carrello</a>
              <a [routerLink]="['/shop/checkout']" class="checkout">Checkout</a>
            </div>
          </li>
        </ul>
      </ng-container>
    </li>
  </ul>
</div>